
import Vue from "vue";

export default Vue.extend({
  name: "PopoverMenu",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true
  })
});
